import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSnackbarContext } from 'Context/SnackbarContext';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { useOnboardingPlannerViewSectionContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import OnboardingPlannerViewSectionNote
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionNote';
import fr from 'facet-rest';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1, 0),
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  form: {
    padding: 0,
    marginBottom: theme.spacing(4),
  },
  notes: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: theme.spacing(0, 4),
  },
  note: {
    marginRight: theme.spacing(2),
  },
});

const ViewFormSkeleton = () => {
  return (
    <></>
  );
};

ViewFormSkeleton.defaultProps = {
};

ViewFormSkeleton.propTypes = {
  classes: PropTypes.object.isRequired,
};


const ViewForm = ({
  className,
  classes,
  layout,
  metaOverrideSet,
}) => {
  const {
    viewSectionResource, noteCollection, onEditNote, onDeleteNote,
  } = useOnboardingPlannerViewSectionContext();
  const { displayErrorMessage } = useSnackbarContext();

  if (!viewSectionResource) {
    return <ViewFormSkeleton classes={classes} />;
  }

  const fieldsToHide = viewSectionResource.meta().template().list().map(field => field.attr('name'));

  return (
    <div className={classes.root}>
      <MetaFormInline
        classes={{
          root: classNames(classes.root, className),
          form: classes.form,
        }}
        resource={viewSectionResource}
        metaOverrideSet={metaOverrideSet}
        layout={layout}
        LayoutProps={{
          excludedFromRemainingFields: fieldsToHide,
          hideErrorList: true,
        }}
        readonly // <--- Hides default Submit button
        onFailure={(err) => {
          if (err.status !== 400) {
            displayErrorMessage(err, err.errors);
          }
        }}
        component={({ children }) => children}
      />
      <div className={classes.notes}>
        {noteCollection && noteCollection.resources().list().map(noteResource => {
          return (
            <OnboardingPlannerViewSectionNote
              key={noteResource.id()}
              className={classes.note}
              profileImageLink={noteResource.relationship(fr.relationships.creatorProfileImage.name)?.link('related')}
              noteContent={noteResource.attr('content')}
              onEdit={() => {
                onEditNote(noteResource);
              }}
              onDelete={() => {
                onDeleteNote(noteResource);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

ViewForm.defaultProps = {
  className: '',
  layout: null,
  metaOverrideSet: null,
};

ViewForm.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  layout: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  metaOverrideSet: PropTypes.object,
};

export default withStyles(styles)(ViewForm);
